import { useCitrusView } from '../../contexts/CitrusViewContext';
import { useUser } from '../../contexts/UserContext';
import { Button } from '../../components/Button/NewButton';
import { Tooltip } from '../../components/Tooltip';

export const ConnectControls = () => {
  const { connect, connectedUser, disconnect, rebooting } = useCitrusView();
  const { email } = useUser();

  const renderButtons = () => {
    if (connectedUser == email)
      return (
        <Button onClick={disconnect} theme="text">
          DISCONNECT
        </Button>
      );

    if (connectedUser)
      return (
        <Button onClick={connect} theme="text">
          TAKE CONTROL
        </Button>
      );

    return (
      <Button onClick={connect} disabled={rebooting}>
        CONNECT
      </Button>
    );
  };

  const renderUser = () => {
    if (!connectedUser || connectedUser === email) return;

    // if (connectedUser === email) return <p>You are connected</p>;

    return (
      <div className="inline-flex gap-2 whitespace-nowrap">
        <Tooltip title={connectedUser}>
          <span className="bg-amber-200 text-amber-900 font-bold rounded-full p-2 m-1">
            {connectedUser.slice(0, 2).toUpperCase()}
          </span>{' '}
        </Tooltip>
        <p>is connected</p>
      </div>
    );
  };

  return (
    <div className="flex flex-col md:flex-row items-center gap-2">
      {renderUser()}
      {renderButtons()}
    </div>
  );
};
